export default {
  rounds: state => state.rounds,
  roundsOption: ({ rounds }) => rounds.map(({ name, id, status, tokenId }) => ({
    value: id, text: name || 'Unknown', status, tokenId,
  })),
};
